import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { VerifyPage } from "../pages/VerifyPage";
import { useAuthStore } from "../auth/auth.store";

function VerifyRoute() {
  const navigate = useNavigate();
  const pending = useAuthStore((state) => state.pending);
  const verified = useAuthStore((state) => state.verified);
  const verifyCode = useAuthStore((state) => state.verifyCode);
  const resendCode = useAuthStore((state) => state.resendCode);

  useEffect(() => {
    if (verified) navigate("/success");
  }, [verified, navigate]);
  return <>
  <VerifyPage pending={pending} onVerify={verifyCode} onResend={resendCode} />
  </>

}

export default VerifyRoute;